import React, { Component } from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
//import { HashRouter as Router, Routes, Route } from 'react-router-dom';
//import { HashRouter, Link, Routes, Route } from 'react-router-dom';
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./components/Home";
import News from "./components/News";
import Resume from "./components/Resume";
import Contact from "./components/Contact";
import AI from "./components/AI";
import AITherapist from "./components/AITherapist";
import FruitClassification from "./components/FruitClassification";
import ReactGA from 'react-ga';
import CriminalJusticeDataAnalysis from './components/CriminalJusticeDataAnalysis';
import WellnessSupportAgent from './components/WellnessSupportAgent';

class App extends Component {
  setGA = () => {
    ReactGA.initialize('G-4Z7X4CJTCC');
    ReactGA.pageview('Init page view');
  };
  componentDidMount(){
    this.setGA();
  }
  render() {
    return (
      <div className="App">
        <Router>
          <Navbar />
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route exact path="/ai-projects" element={<AI />} />
            <Route path="/news" element={<News />} />
            <Route path="/resume" element={<Resume />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/fruit-classification" element={<FruitClassification />} />
            <Route path="/ai-therapist" element={<AITherapist />} />
            <Route path="/criminal-justice-data-analysis" element={<CriminalJusticeDataAnalysis />} />
            <Route path="/wellness-support-agent" element={<WellnessSupportAgent />} />
          </Routes>
          <Footer />
        </Router>
      </div>
    );
  }
}

export default App;


      // <Router>
      //   <div className="App">
      //     <Navbar />
      //     <Routes>
      //       <Route path="/" element={<Home />} />
      //       <Route path="/news" element={<News />} />
      //       <Route path="/resume" element={<Resume />} />
      //       <Route path="/contact" element={<Contact />} />
      //     </Routes>
      //     <Footer />
      //   </div>
      // </Router>


      // <Router>
      //   <div className="App">
      //     <ul className="App-header">
      //       <li>
      //         <Link to="/">Home</Link>
      //       </li>
      //       <li>
      //         <Link to="/news">News</Link>
      //       </li>
      //       <li>
      //         <Link to="/resume">Resume</Link>
      //       </li>
      //       <li>
      //         <Link to="/contact">Contact</Link>
      //       </li>
      //     </ul>
      //     <Routes>
      //       <Route exact path='/' component={<Home />}>
      //       </Route>
      //       <Route exact path='/news' component={<News />}>
      //       </Route>
      //       <Route exact path='/resume' component={<Resume />}>
      //       </Route>
      //       <Route exact path='/contact' component={<Contact />}>
      //       </Route>
      //     </Routes>
      //   </div>
      // </Router>
